"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MedicalLab = void 0;
var Tags_1 = require("../Tags");
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var Resources_1 = require("../../Resources");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var MedicalLab = (function (_super) {
    __extends(MedicalLab, _super);
    function MedicalLab() {
        return _super.call(this, {
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.MEDICAL_LAB,
            tags: [Tags_1.Tags.SCIENCE, Tags_1.Tags.BUILDING],
            cost: 13,
            metadata: {
                cardNumber: '207',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) {
                        pb.megacredits(1).slash().building(2).played;
                    });
                }),
                description: 'Increase your M€ production 1 step for every 2 Building tags you have, including this.',
                victoryPoints: 1,
            },
        }) || this;
    }
    MedicalLab.prototype.produce = function (player) {
        var includeThis = !player.cardIsInEffect(this.name);
        var tagCount = player.getTagCount(Tags_1.Tags.BUILDING) + (includeThis ? 1 : 0);
        player.addProduction(Resources_1.Resources.MEGACREDITS, Math.floor(tagCount / 2), { log: true });
    };
    MedicalLab.prototype.play = function (player) {
        this.produce(player);
        return undefined;
    };
    MedicalLab.prototype.getVictoryPoints = function () {
        return 1;
    };
    return MedicalLab;
}(Card_1.Card));
exports.MedicalLab = MedicalLab;
//# sourceMappingURL=MedicalLab.js.map